import { useAuth0 } from '@auth0/auth0-react';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';

export function useDatadogUser() {
  const { isAuthenticated, user } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated || !user?.sub) {
      datadogRum.clearUser();
      return;
    }

    datadogRum.setUser({
      id: user.sub,
    });
  }, [isAuthenticated, user]);
}
